import React from "react";

let closeIcon = new URL(
  "../assets/images/icon-close-dark.svg",
  import.meta.url
);

const ModalPopup = ({ title, children, onClose }) => {
  return (
    <div
      className="fixed z-50 flex w-full h-full justify-center items-center"
      style={{ backgroundColor: "rgba(0, 39, 51, .5)" }}
    >
      <div className="flex justify-center max-h-[90%] w-full">
        <div className="flex flex-col w-auto p-6 bg-[#fafbfb] rounded relative drop-shadow-xl w-[90%]">
          <div className="self-end mb-1">
            <img
              src={closeIcon}
              alt="close"
              width="24"
              height="24"
              className="h-fit max-w-none cursor-pointer absolute p-1 right-3 top-3"
              onClick={onClose}
            />
          </div>
          <div className="overflow-auto">{children}</div>
        </div>
      </div>
    </div>
  );
};

export default ModalPopup;
